import React from 'react';
import { ButtonWithAsProp } from '../Button';
import { ValuesOf } from '../utils/typeUtils';
import { SKINS, SIZES } from './CloseButton.constants';

export type CloseButtonProps = ButtonWithAsProp<{
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Used for passing any @wix/design-system icon. For external icon make sure to follow ux sizing guidelines */
  children?: React.ReactNode;
  /** skins of closebutton */
  skin?: CloseButtonSkin;
  /** size of closebutton */
  size?: CloseButtonSize;
  /** applies disabled styles */
  disabled?: boolean;
  /** Focus the button on mount */
  autoFocus?: boolean;
  /** string based data hook for testing */
  dataHook?: string;
}>;

export type CloseButtonSkin = ValuesOf<typeof SKINS>;
export type CloseButtonSelectionArea = 'none' | 'hover' | 'always';
export type CloseButtonSize = ValuesOf<typeof SIZES>;
